import { API } from "@thenounproject/lingo-core";
import { createAsyncAction } from "../actionCreators";

type TagUpdate = { uuid: string; keywords: string };

const [useSaveMultipleAssetTags, saveMultipleAssetTags] = createAsyncAction(
  {
    action: "assets/saveMultipleAssetTags",
    undo: {
      message: (args: TagUpdate[]) => `Updated tags on ${args.length} asset(s)`,
      captureState: (args: TagUpdate[], { getState }) => {
        const assets = getState().entities.assets.objects;
        return args.map(update => ({
          uuid: update.uuid,
          keywords: (assets[update.uuid] as { keywords?: string })?.keywords ?? "",
        }));
      },
      performUndo: (_: TagUpdate[], captured: unknown, { dispatch }) => {
        void dispatch(saveMultipleAssetTags(captured as TagUpdate[]));
      },
    },
  },
  async (updates: TagUpdate[]) => {
    const res = await API.call<{ assets: string }>({
      endpoint: "sync/assets",
      method: "POST",
      data: { assets: updates },
    });
    return { ...res, result: res.result.assets };
  }
);

export default useSaveMultipleAssetTags;
export { saveMultipleAssetTags };
